import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VrskFormlyRepeatTypeComponent } from './types/vrsk-formly-repeat-type/vrsk-formly-repeat-type.component';
import { FormlyModule } from '@ngx-formly/core';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { VrskFormlyFlexLayoutComponent } from './types/vrsk-formly-flex-layout/vrsk-formly-flex-layout.component';
import { WidgetsQuestionWrapperComponent } from './wrappers/widgets-question-wrapper.component';
import { MatCardModule } from '@angular/material/card';
import { WidgetsSectionWrapperComponent } from './wrappers/widgets-section-wrapper.component';
import { WidgetsFieldWrapperComponent } from './wrappers/widgets-field-wrapper.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from "@angular/material/form-field";
import { WidgetsModule } from '../widgets/widgets.module';
import {FormlySelectModule} from '@ngx-formly/core/select';

@NgModule({
  declarations: [
    VrskFormlyRepeatTypeComponent,
    VrskFormlyFlexLayoutComponent,
    WidgetsQuestionWrapperComponent,
    WidgetsSectionWrapperComponent,
    WidgetsFieldWrapperComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatRadioModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatFormFieldModule,
    FormlySelectModule,
    FormlyModule.forChild(),
    ReactiveFormsModule,
    FormlyModule.forRoot({
      validationMessages: [{ name: 'required', message: 'This field is required' }],
    }),
    WidgetsModule
  ],
})
export class VrskFormlyModule { }
